"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTableRowCell = exports.StyledTableRowContainer = void 0;
// styles
const Theme_1 = require("../../Theme/Theme");
exports.StyledTableRowContainer = Theme_1.styled.tr `
  border: 1px solid ${(props) => props.theme.colors.gray[30]};
  background-color: ${(props) => props.theme.white};
  height: ${(props) => (props.height ? `${props.height}px` : 'auto')};
  ${(props) => props.onClick &&
    `&:hover {
      cursor: pointer;
      background-color: ${props.theme.colors.gray[10]};
  }`}
`;
exports.StyledTableRowCell = Theme_1.styled.td `
  text-align: ${(props) => props.alignment || 'left'};
  width: ${(props) => (props.width ? `${props.width}%` : 'auto')};
  font-family: proxima-nova, sans-serif;
  font-size: 12px;
  padding: 12px 16px;
  ${(props) => props.alignment === 'right' && `padding-right: 28px;`}
  &:first-child {
    padding-left: 24px;
  }
  ${(props) => props.columnIndex === props.sortedColumnIndex &&
    props.isSortAnimating &&
    `animation: fade 2900ms linear;
  @keyframes fade {
  0%,100% { background-color: 'transparent' }
  5%, 90% { background-color: ${props.theme.colors.blue[10]} }`}
}
`;
//# sourceMappingURL=TableRow.styles.js.map